import React, { Component, Fragment } from "react";

export default class Menu extends Component {

    botaoAtivo(path) {
        if(this.props.categoriaSelecionada === path) {
            return { backgroundColor: "#148a9c" }
        }
        else return {}
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                        <div className="col-md-12 ml-auto mr-auto">
                            {/*<a href="/"><button className="btn btn-btn-danger" >Voltar</button></a>*/}
                            <button className="btn btn-primary" style={this.botaoAtivo(0)} onClick={() => this.props.escolheCategoria(0)}>Consultoria em Tecnologia</button>
                            <button className="btn btn-primary" style={this.botaoAtivo(1)} onClick={() => this.props.escolheCategoria(1)}>Serviços Técnicos Especializados</button>
                            <button className="btn btn-primary" style={this.botaoAtivo(2)} onClick={() => this.props.escolheCategoria(2)}>Pesquisa, Desenvolvimento e Inovação</button>
                            <button className="btn btn-primary" style={this.botaoAtivo(3)} onClick={() => this.props.escolheCategoria(3)}>Metrologia</button>
                            <button className="btn btn-primary" style={this.botaoAtivo(4)} onClick={() => this.props.escolheCategoria(4)}>Serviços Complementares</button>
                        </div>
                    </div>
            </Fragment>
        )
    }

}